import React, { useState, useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import style from './style.module.css';

import Loader from '../../assets/images/loader.svg';

import { getLabel, falseEmailsTitleLabel, falseEmailsContentLabel, Language, getLanguageArray, systemLanguage, urlFalseEmails, urlArticle, getToken, getUuid, previousLabel, nextLabel } from '../../utils/constants';
import { getFakeEmailArticles } from '../../services/cmsApi';
import { faArrowLeft, faArrowRight } from '@fortawesome/free-solid-svg-icons';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const FalseEmailsView: React.FC = () => {
  const { page_number } = useParams();

  const userToken = getToken()
  const userUuid = getUuid() 

  const [loading, setLoading] = useState(true);
  const [articles, setArticles] = useState<any[] | boolean>(false);
  const [totalPages,setTotalPages] = useState(0);
  const [sessionLang, setSessionLang] = useState<Language>(getLanguageArray());

  const fetchArticles = async (page: number) => {
    setLoading(true);
    const response = await getFakeEmailArticles({ uuid: userUuid, token: userToken, page_number: page });
    setArticles(response.alerts || []);
    setTotalPages(response.pagination.totalPages || 1);
    setLoading(false);
  };

  useEffect(() => {
    const handler = (e: StorageEvent) => {
      if (e.key === systemLanguage && e.newValue) {
        setSessionLang(JSON.parse(e.newValue));
      }
    };
    window.addEventListener('storage', handler);
    return () => window.removeEventListener('storage', handler);
  }, []);

  useEffect(() => {
    const page = parseInt(page_number ?? '1', 10);
    fetchArticles(page);
  }, [page_number]);

  const currentPage = parseInt(page_number ?? '1', 10);

  window.scroll(0,0)

  return (
    <div className={style.falseEmails}>
      <div className={style.header}>
        <div className={`${style.greeting} ${style.textContainerGrad}`}>
          {getLabel(falseEmailsTitleLabel, sessionLang)}
        </div>
        <div className={style.info}>
          {getLabel(falseEmailsContentLabel, sessionLang)}
        </div>
      </div>

      <div className={style.collection}>
        {loading ? (
          <div className={style.loader}>
            <img src={Loader} alt="Loading" />
          </div>
        ) : !Array.isArray(articles) || articles.length === 0 ? (
          <div className={style.noArticles}>No articles found.</div>
        ) : (
          articles.map((article, index) => (
            <Link to={urlFalseEmails + urlArticle + '/' + article.uuid}>
              <div className={style.article} key={article.uuid || index}>
                <div className={style.topBar}>
                  <div className={style.category}>
                    <div className={style.block}>{article.category}</div>
                  </div>
                  <span>{/*article.date*/}</span>
                </div>
                <div className={style.articleLogo}>
                  <img src={process.env.REACT_APP_CDN_URL + '/' + article.logo} alt="logo" />
                </div>
                <div className={style.title}>
                    {article.title?.EN || article.title?.NL}
                </div>
              </div>
            </Link>
          ))
        )}

        {
            !loading ?  
                <div className={style.pagination}>
                    <div className={style.paginationButton}>
                        {currentPage !== 1 && (
                          <><span><FontAwesomeIcon icon={faArrowLeft} /></span><Link to={urlFalseEmails + '/' + (currentPage - 1)}>{getLabel(previousLabel, sessionLang)}</Link></>
                        )}
                    </div>
                    <div className={style.paginationButton}>
                      {currentPage !== totalPages && (
                         <><Link to={urlFalseEmails + '/' + (currentPage + 1)}>{getLabel(nextLabel, sessionLang)}</Link><span><FontAwesomeIcon icon={faArrowRight} /></span></>
                      )}
                    </div>
                </div> : ''
        }
      </div>
    </div>
  );
};

export default FalseEmailsView;
